import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

/**
 * Wrap gated routes. Three outcomes:
 *   user === null   → still checking → render blank splash (avoid flash)
 *   user === false  → not authed     → redirect to /login (remember where they wanted to go)
 *   user is object  → authed         → render children
 *
 * NOTE: this replaces the site-password `AuthGate` for real users. The
 * site-password gate still lives in the backend middleware as a rollback
 * path — a curl caller with the legacy `se_session` cookie can still hit
 * `/api/experts` — but the SPA now sends every visitor through user auth.
 */
export default function RequireUser({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div
        data-testid="auth-checking"
        className="fixed inset-0 z-50 bg-[#0b1120]"
        aria-hidden="true"
      />
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
